module.exports = {"component":"popover","status":"prod","display-name":"Popovers","last-accessibility-review":{"date-iso-8601":"2018/01/18","commit-sha":"ad6b6c6523ee21cada11be5f7ea4d99abc530726"},"SLDS-component-path":"/components/popovers","url-slug":"popovers"}


//////////////////
// WEBPACK FOOTER
// ./components/popover/docs.json
// module id = 222
// module chunks = 0